<!-- 代码表管理 -->
<template>
<div>
  <Table
    ref="table"
    :loadObj='{}'
    :dict="[]"
    :option="{}"
    :colObj='{
      opId:"127",
      col:[],
    }'
  >
  </Table>
</div>
</template>
<script>
import Table from '@/components/table/dataTablec';
export default {
  components: {
    Table
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {
  },
  mounted() {},
  activated() {
  },
};
</script>

<style></style>
